import Alert from '@mui/material/Alert';
import { Collapse } from 'react-bootstrap';

export default function ModalSuccessMessage({ message, setShow }) {
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setShow(false);
  };

  return (
    <Collapse in={!!message} sx={{ mt: 1, mb: 1 }}>
      <Alert severity="success" onClose={handleClose}>
        {message}
      </Alert>
    </Collapse>
  );
}
